import { useContext, useEffect, useState } from "react";
import { LoggedRecruiter } from "../models/LoggedRecruiter";
import { AuthContext } from "../providers/AuthContextProvider";
import { StyleContext } from "../providers/StyleContextProvider";
import { createSearchParams, useLocation, useNavigate, useParams } from "react-router-dom";
import { RecruiterMenu } from "../components/Shared/RecruiterMenu";
import { Button } from "../components/Shared/Buttons/Button";
import { ReactComponent as LeftArrow } from "../assets/svg/left_arrow.svg";
import useErrorPage from "../hooks/useErrorPage";
import { getInvoice, getInvoiceDetails } from "../services/RecruiterService";
import { useMediaQuery } from "react-responsive";
import { PaymentIcons } from "../helpers/LayoutTexts";
import { Footer } from "../components/Shared/Footer";
import { postCheckoutRequest } from "../services/CheckoutService";
import { WebXPayModel } from "../models/WebXPayModel";
import { CheckoutModel } from "../models/CheckoutModel";
import { CheckoutTypes } from "../enums/CheckoutTypes";
import $ from 'jquery';
import { DocumentViewer } from "../components/Shared/DocumentViewer";
import { ReactComponent as ExternalLink } from '../assets/svg/external-link.svg';
import { PopUpWindow } from "../components/Shared/PopUpWindow";
import { InvoiceLoader } from "../components/Loaders/InvoiceLoader";
import { InvoicePaymentLoader } from "../components/Loaders/InvoicePaymentLoader";
import { getHost } from "../helpers/Common";
import { ProfileEntrance } from "../components/Home/ProfileEntrance";

type PaymentModel = {
    checkoutTypeId: number;
    invoiceId: number;
    refId: number;
    total: number;
}

const intialFormInputs: CheckoutModel = {     
    fullName: "",
    email: "",
    promoCode: ""
}

export const InvoicePaymentPage: React.FC = () => {  
    const location = useLocation();  
    const navigate = useNavigate();
    const { refId } = useParams();
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("invoicePaymentPage"));  
    const [pdfUrl, setPdfUrl] = useState<string>("");
    const [invoiceData, setInvoiceData] = useState<PaymentModel>();
    const [checkout, setCheckout] = useState<CheckoutModel>(intialFormInputs);
    const [price, setPrice] = useState<number>(0);
    const [openInvoicePopUp, setOpenInvoicePopUp] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)"}); 
    const [loading, setLoading] = useState(true);
    const [toErrorPage] = useErrorPage(); 

    useEffect(() => {
        if(recruiter === null) {   
            const params = { callbackUrl: location.pathname + location.search, message: "Please login or register to access the invoice manager." };
            navigate({
                pathname: '/recruiter/account/login',
                search: `?${createSearchParams(params)}`
            });            
        }   
        else {  
            getInvoiceData(); 
            let tempFormInputs: CheckoutModel = {  
                recruiterId: recruiter.recruiterId,   
                fullName: recruiter.forename + " " + recruiter.surname,
                email: recruiter.email,
                promoCode: "",
            }
            setCheckout(tempFormInputs);
        } 
    }, []);

    const navigateToVacancies = () => {
        navigate("/recruiter/vacancy");
    };

    async function getInvoiceData() {
        await getInvoiceDetails(refId!, recruiter!.recruiterId, recruiter!.token)
        .then((response: PaymentModel) => {
            setInvoiceData(response);
            setPrice(response.total);
            getPendingInvoice(response.invoiceId);
            setLoading(false);
        })
        .catch((error) => {
            toErrorPage(error);            
        });
    };

    async function getPendingInvoice(invoiceId: number, isDownload: boolean = false) {
        await getInvoice(invoiceId, recruiter!.recruiterId, recruiter!.token, isDownload)
        .then((response: any) => {
            if (isDownload) {
                const link = document.createElement("a");
                link.href = response.url;
                link.download = response.filename;
                link.click();
            } 
            else {
                let url = getHost() + `api/recruiter/invoice?invoiceId=${invoiceId}&recruiterId=${recruiter!.recruiterId}&token=${recruiter!.token}&download=${isDownload}`;
                setPdfUrl(url);
            }
        })
        .catch((error) => {
            toErrorPage(error);            
        });
    };

    async function handleCheckoutClick() {
        checkout.checkoutType = CheckoutTypes.Invoice;
        checkout.price = price;
        checkout.refId = invoiceData?.refId.toString();
        await postCheckoutRequest(checkout)
        .then((webXPayModel: WebXPayModel) => {
            $('.checkout').append(
            '<form action="' + webXPayModel.checkoutUrl + '" id="invoiceForm" name="form" method="post" style="display:none;">' +
                '<input type="text" name="first_name" value="' + webXPayModel.firstName + '" />' +
                '<input type="text" name="last_name" value="' + webXPayModel.lastName + '" />' +
                '<input type="text" name="email" value="' + webXPayModel.email + '" />' +
                '<input type="text" name="contact_number" value="' + webXPayModel.contactNumber + '" />' +
                '<input type="text" name="address_line_one" value="' + webXPayModel.address + '" />' +
                '<input type="text" name="process_currency" value="' + webXPayModel.currency + '" />' +
                '<input type="text" name="secret_key" value="' + webXPayModel.secretKey + '" />' +
                '<input type="text" name="custom_fields" value="' + webXPayModel.customFields + '" />' +
                '<input type="text" name="payment" value="' + webXPayModel.paymentStr + '" />' +
            '</form>');       
            var checkoutForm = document.getElementById("invoiceForm") as HTMLFormElement;
            checkoutForm.submit();
        })
        .catch((error) => {
            toErrorPage(error);            
        });
    };

    return (
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.leftWrapper}>
                    <RecruiterMenu>
                        <div style={styles.title}>{"Invoice Payment"}</div>
                    </RecruiterMenu>
                </div>
                <div style={styles.rightWrapper}>
                    <div style={styles.backButton.container} onClick={navigateToVacancies}>
                        <Button style={styles.backButton.button}><LeftArrow style={styles.backButton.icon} /></Button>
                        <span style={styles.backButton.text}>{"Back"}</span>
                        <div style={styles.backButton.profileWrapper}><ProfileEntrance recruiter={recruiter} /></div>
                    </div>
                    {!isMobile && <div style={styles.title}>{"Invoice Payment"}</div>}
                    <div style={styles.invoiceWrapper}>
                        <div style={styles.pdfViewer}>
                            {pdfUrl ? (
                                isMobile ? 
                                    <>
                                        <div>
                                            <div style={styles.invoiceViewer.rowWrapper}>
                                                <div style={styles.invoiceViewer.text}>Invoice</div>
                                                <div style={styles.invoiceViewer.link} onClick={() => setOpenInvoicePopUp(true)}>
                                                    View Invoice <ExternalLink style={styles.invoiceViewer.icon} />
                                                </div>
                                                <Button style={styles.invoiceViewer.button} onClick={() => getPendingInvoice(invoiceData!.invoiceId, true)}>{"Download"}</Button>
                                            </div>
                                            <div style={styles.invoiceViewer.holder}>
                                                <div style={styles.invoiceViewer.layer}></div>
                                                <DocumentViewer document={pdfUrl} styles={styles.invoiceViewer.documentViewer}/>
                                            </div>
                                        </div>
                                        <PopUpWindow styles={styles.popup} open={openInvoicePopUp} toggle={() => setOpenInvoicePopUp(!openInvoicePopUp)} closeCircle={true}>
                                            <DocumentViewer document={pdfUrl} styles={styles.popup.documentViewer}/>                
                                        </PopUpWindow>
                                    </> 
                                    : <embed 
                                        src={pdfUrl} 
                                        title={"invoiceId"}
                                        width="100%" 
                                        height="800" 
                                        type="application/pdf" 
                                    />
                            ) : <InvoiceLoader/>}
                        </div>
                        {loading ? <InvoicePaymentLoader/> : <div style={styles.checkout}>            
                            <p style={styles.checkout.priceRow}>Total <span style={styles.checkout.priceValue}>{invoiceData?.total} LKR</span></p>
                            <Button type="button" style={styles.checkout.checkoutButton} onClick={() => handleCheckoutClick()}>{"PROCEED TO CHECKOUT"}</Button> 
                            <div style={styles.checkout.iconGride}>
                                {PaymentIcons.map((paymentIcon, index) =>                    
                                    <img key={index} src={paymentIcon} style={styles.checkout.paymentIcon}/>                    
                                )}
                            </div> 
                            <p style={styles.checkout.note}>{"Kindly note that we're unable to process any refunds."}</p>              
                        </div>}
                    </div>           
                </div>
            </div>
            <div className="checkout"></div>
            <Footer/>
        </>
    )
}